export const DEFAULT_ATTORNEY_FEE_SETTINGS = Object.freeze({
  base_chapter_7: 1200,
  chapter_7_joint_additional: 100,
  chapter_7_reaffirmation_additional: 50,
  chapter_7_self_employed_additional: 100,
  chapter_13_unsecured_fee: 4000,
  chapter_13_max_fee: 4500,
});

const toFeeAmount = (value, fallback) => {
  const normalized = String(value ?? '').replace(/[$,]/g, '').trim();
  if (!normalized) return fallback;

  const amount = Number(normalized);
  return Number.isFinite(amount) && amount >= 0 ? amount : fallback;
};

export const normalizeAttorneyFeeSettings = (settings = {}) =>
  Object.fromEntries(
    Object.entries(DEFAULT_ATTORNEY_FEE_SETTINGS).map(([key, fallback]) => [
      key,
      toFeeAmount(settings?.[key], fallback),
    ])
  );

export const resolveAttorneyFeeSettings = (answers = {}) =>
  normalizeAttorneyFeeSettings(
    answers.attorney_fee_settings || answers.attorneyFeeSettings || {}
  );

const vehicleHasLoan = (vehicle = {}) =>
  vehicle.loan === 'loan' || toFeeAmount(vehicle.loanBalance, 0) > 0;

export const hasChapter13SecuredDebt = (answers = {}) =>
  (answers.ownsHome === 'yes' &&
    (answers.hasMortgage === 'yes' || answers.hasSecondMortgage === 'yes')) ||
  [...(answers.vehicles || []), ...(answers.spouseVehicles || [])].some(vehicleHasLoan);

export const getChapter13TotalAttorneyFee = (answers = {}) => {
  const settings = resolveAttorneyFeeSettings(answers);
  return hasChapter13SecuredDebt(answers)
    ? settings.chapter_13_max_fee
    : settings.chapter_13_unsecured_fee;
};

